/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActionEnum } from './ActionEnum';
import { ActionEnumFromJSON, ActionEnumFromJSONTyped, ActionEnumToJSON } from './ActionEnum';

/**
 *
 * @export
 * @interface FindingChangelog
 */
export interface FindingChangelog {
  /**
   *
   * @type {number}
   * @memberof FindingChangelog
   */
  readonly id: number;
  /**
   *
   * @type {ActionEnum}
   * @memberof FindingChangelog
   */
  readonly action: ActionEnum;
  /**
   *
   * @type {string}
   * @memberof FindingChangelog
   */
  readonly userName: string;
  /**
   *
   * @type {string}
   * @memberof FindingChangelog
   */
  readonly userEmail: string;
  /**
   *
   * @type {Date}
   * @memberof FindingChangelog
   */
  readonly timestamp: Date;
}

/**
 * Check if a given object implements the FindingChangelog interface.
 */
export function instanceOfFindingChangelog(value: object): value is FindingChangelog {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('action' in value) || value['action'] === undefined) return false;
  if (!('userName' in value) || value['userName'] === undefined) return false;
  if (!('userEmail' in value) || value['userEmail'] === undefined) return false;
  if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
  return true;
}

export function FindingChangelogFromJSON(json: any): FindingChangelog {
  return FindingChangelogFromJSONTyped(json, false);
}

export function FindingChangelogFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindingChangelog {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    action: ActionEnumFromJSON(json['action']),
    userName: json['user_name'],
    userEmail: json['user_email'],
    timestamp: new Date(json['timestamp']),
  };
}

export function FindingChangelogToJSON(
  value?: Omit<FindingChangelog, 'id' | 'action' | 'userName' | 'userEmail' | 'timestamp'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {};
}
